var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 240,
    viewBox: "0 0 425 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1613_264039",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 425,
    height: 240
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.00001C0 3.58173 3.58172 0 8 0H417C421.418 0 425 3.58172 425 8V240H0V8.00001Z",
    fill: "#E6E6E6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1613_264039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.00001C0 3.58173 3.58172 0 8 0H417C421.418 0 425 3.58172 425 8V240H0V8.00001Z",
    fill: "url(#paint0_radial_1613_264039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.216 96.2812C197.34 95.7724 197.34 94.5069 198.216 93.9981L211.1 86.5173C211.504 86.2826 212.002 86.2792 212.41 86.5084L225.709 93.9892C226.606 94.4938 226.606 95.7855 225.709 96.2902L212.41 103.771C212.002 104 211.504 103.997 211.1 103.762L198.216 96.2812Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.913 115.522C196.503 115.287 196.25 114.85 196.25 114.377V99.4539C196.25 98.4393 197.347 97.804 198.227 98.309L210.362 105.272C210.772 105.507 211.025 105.944 211.025 106.417V121.34C211.025 122.354 209.928 122.99 209.048 122.485L196.913 115.522Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.791 98.2655C226.671 97.7762 227.753 98.4124 227.753 99.4191V114.364C227.753 114.844 227.492 115.286 227.072 115.518L214.434 122.518C213.554 123.005 212.475 122.369 212.475 121.363V106.447C212.475 105.968 212.734 105.526 213.153 105.293L225.791 98.2655Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.966 127.327C180.09 126.818 180.09 125.553 180.966 125.044L193.85 117.563C194.254 117.329 194.752 117.325 195.16 117.554L208.459 125.035C209.356 125.54 209.356 126.831 208.459 127.336L195.16 134.817C194.752 135.046 194.254 135.043 193.85 134.808L180.966 127.327Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.663 146.568C179.253 146.333 179 145.896 179 145.423V130.5C179 129.485 180.097 128.85 180.977 129.355L193.112 136.318C193.522 136.553 193.775 136.99 193.775 137.463V152.386C193.775 153.4 192.678 154.036 191.798 153.531L179.663 146.568Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.541 129.311C209.421 128.822 210.503 129.458 210.503 130.465V145.41C210.503 145.89 210.242 146.332 209.822 146.564L197.184 153.564C196.304 154.051 195.225 153.415 195.225 152.409V137.493C195.225 137.014 195.484 136.572 195.903 136.339L208.541 129.311Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.466 125.044C214.59 125.553 214.59 126.818 215.466 127.327L228.35 134.808C228.754 135.043 229.252 135.046 229.66 134.817L242.959 127.336C243.856 126.831 243.856 125.54 242.959 125.035L229.66 117.554C229.252 117.325 228.754 117.329 228.35 117.563L215.466 125.044Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.5 145.423C213.5 145.896 213.753 146.333 214.163 146.568L226.298 153.531C227.178 154.036 228.275 153.4 228.275 152.386V137.463C228.275 136.99 228.022 136.553 227.612 136.318L215.477 129.355C214.597 128.85 213.5 129.485 213.5 130.5V145.423Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.003 130.465C245.003 129.458 243.921 128.822 243.041 129.311L230.403 136.339C229.984 136.572 229.725 137.014 229.725 137.493V152.409C229.725 153.415 230.804 154.051 231.684 153.564L244.322 146.564C244.742 146.332 245.003 145.89 245.003 145.41V130.465Z",
    fill: "#B2B2B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1613_264039",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(212.5 120) rotate(90) scale(201.5 356.823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImg);
export default __webpack_public_path__ + "static/media/defaultImg.5279332ceee6bed3e7d1c59fc9b152d2.svg";
export { ForwardRef as ReactComponent };